import _styled from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@adsk/alloy-react-divider';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const Footer = _ref => {
  let {
    style,
    className,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: '15px 0'
    }
  }), /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      padding: "0 ".concat(theme.spacing.M, "px"),
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    }, style]
  }, children));
};
Footer.displayName = 'DatePickerFooter';
Footer.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Footer content */
  children: PropTypes.any
};
export default Footer;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Footer___StyledDiv",
  componentId: "sc-8lm0um-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Footer.js.map